document.addEventListener("DOMContentLoaded", async function(){
    // await initLQProductTiles();
    // await populateSwatchButtons();
    await fieldset_swatches();
    await initQuickAdd();
    initCardScrollers();

    const handleResizeSwatches = oofosThrottle( async () => {
        initCardScrollers();
    }, 100);
    window.addEventListener('resize', handleResizeSwatches);
});

async function swapTheProduct(productHandle) {
    let section = await fetch(`${window.Shopify.routes.root}products/${productHandle}?sections=main-product,title,caption,price,variant_picker,buy_buttons,description`).then( z => z.json() ).then( y => {
        document.querySelector('product-info').innerHTML = y['main-product'];
    });
}

const SWATCH_DATA = JSON.parse(document.getElementById('all-swatch-data').getAttribute('data-swatches'));
// if( SWATCH_DATA ){
//     SWACTH_DATA JSON.parse(SWATCH_DATA) );
// }

async function initLQProductTiles() {
    let productTiles = document.querySelectorAll('.lq--product-tile');
    if( !productTiles ) return;

    // console.log('productTiles,',productTiles)
    
    const productPromises = Array.from(productTiles).map( async( product ) => {
        await initLQProductTile(product);
    });
    
    const prod_promises = await Promise.all(productPromises);

}
async function initLQProductTile(product_tile, selectedSwatch = false) {
    // console.log('product_tile',product_tile)
    let productGroupTag = product_tile.getAttribute('data-product-group');
    let productColor = selectedSwatch ? selectedSwatch : product_tile.getAttribute('data-product-color');
    const search_prods = await fetch(`${window.Shopify.routes.root}collections/all-products-no-minimum/${productGroupTag}?view=json`).then(res => res.json()).then(z => {
        let swatches = '';
        let swatches_container = product_tile.querySelector('.lq--product-tile__body__swatches');
        let colorMatch = false;
        let swatchCounter = 0;
        let swatchesList = '<ul>';
        if( z.products && z.products.length > 0 ){
            z.products.forEach( subproduct => {
                if( subproduct.variants[0].option2 == productColor ){
                    colorMatch = true;
                }else{
                    colorMatch = false;
                }
                let swatchStyle = '';
                let matchedSwatchData = SWATCH_DATA.find( item => item.title === subproduct.variants[0].option2);
                // console.log('matchedSwatchData',matchedSwatchData);
                if( matchedSwatchData ){
                    swatchCounter++;
                    if( matchedSwatchData.image ){
                        swatchStyle = 'background-image:url('+matchedSwatchData.image+');';
                    }else if( matchedSwatchData.color) {
                        swatchStyle = 'background-color:'+matchedSwatchData.color+';';
                    }else{
                        swatchStyle = '';
                    }
                    swatchesList += '<li><button data-color="'+subproduct.variants[0].option2+'" class="swatch-button' + ( colorMatch ? ' selected' : '' ) +'" data-product-handle="'+subproduct.handle+'" data-product-id="'+subproduct.id+'"><div aria-hidden="true" class="inline-swatch" style="'+swatchStyle+'"></div><span class="u-sr-only">Select color: </span><span>'+subproduct.variants[0].option2+'</span></button></li>'
                }
                // if( swatchCounter < 6 ){
                    swatches += '<button style="'+swatchStyle+'" data-color="'+subproduct.variants[0].option2+'" class="swatch-button' + ( colorMatch ? ' selected' : '' ) +'" data-product-handle="'+subproduct.handle+'" data-product-id="'+subproduct.id+'"><span class="u-sr-only">Select color: '+subproduct.variants[0].option2+'</span></button>';
                // }
            })
        }else{
            swatches_container.classList.add('no-swatches')
        }
        let extraSwatches = '';
        if( swatchCounter > 5 ){
            // swatchesList += '</ul>';
            // extraSwatches = '<button>+' +(swatchCounter - 5)+'</button>';
            // extraSwatches += swatchesList;
        }
        swatches_container.innerHTML = swatches + extraSwatches;
        return z;
    });
    
    let swatchButtons = product_tile.querySelectorAll('.swatch-button');
    swatchButtons.forEach( button => {
        button.addEventListener('click', async (e) => {
            let new_product_id = e.target.getAttribute('data-product-id');
            let new_product_handle = e.target.getAttribute('data-product-handle');
            let tile = e.target.closest('.lq--product-tile');
            tile.setAttribute('data-product-id',new_product_id);
            tile.setAttribute('data-product-handle',new_product_handle);
            let new_color = e.target.getAttribute('data-color');

            let sec = await fetch(`${window.Shopify.routes.root}products/${new_product_handle}?sections=lq--product-tile`).then( z => z.json() ).then( y => {
                product_tile.innerHTML = y['lq--product-tile'];
            });
            await initLQProductTile(product_tile,new_color)
        });
    });

    let quickAddButton = product_tile.querySelector('.lq--product-tile__header__quickview')
    // console.log('quickAddButton',quickAddButton)

    quickAddButton.addEventListener('click',async function(e){
        let product_id = e.target.getAttribute('data-product-id');
        console.log('_-_--___----- quick view for: '+product_id)
        let this_dialog = 'dialog_'+product_id;
        let dialog_element = document.getElementById(this_dialog);
        let dialog_content = dialog_element.querySelector('.dialog_content');
        let new_product_handle = dialog_element.getAttribute('data-product-handle');

        // let sec = await fetch(`${window.Shopify.routes.root}products/${new_product_handle}?sections=lq--product-header`).then( z => z.json() ).then( y => {
        //     dialog_content.innerHTML = y['lq--product-header'];
        // });

        //
        const handleResize = oofosThrottle( async () => {
            await resizeProductHeader();
        }, 100)
        
        window.addEventListener('resize', handleResize);
    
        // await initSizeGuideButton();
        // await initATC();
        // await populateSwatchButtons();
        // await initGenderToggleButtons();
        // await resizeProductHeader();
        // await initSizeRadios();
        // await initGalleryZoom();
        await initGenderToggleButtons();
        await changeProductOnPDP(new_product_handle,true,dialog_element);
        //
        
        window[this_dialog].showModal();
    })

    return search_prods;
}
/** PRODUCT HEADER */
async function getOtherProducts(productGroupTag,context = 'pdp'){
        
    let all_color_groups_el;
    let all_color_groups;
    // if( context == 'pdp' ){
    //     all_color_groups_el = document.getElementById('all_color_groups');
    // }else{
    //     all_color_groups_el = context.querySelector('#all_color_groups');
    // }
    // all_color_groups = all_color_groups_el.getAttribute('data-color-groups').split(',');


    const search_prods = await fetch(`${window.Shopify.routes.root}collections/all-products-no-minimum/${productGroupTag}?view=json`).then(res => res.json()).then(z => {
        // console.log('z',z)
        let swatches = [];
        
        // let swatches_container = product_tile.querySelector('.lq--product-tile__body__swatches');
        let colorMatch = false;
        if( z.products && z.products.length > 0 ){
            z.products.forEach( subproduct => {
                // console.log('z--subproduct',subproduct)
                let productColor;
                // if( context == 'pdp' ){
                //     productColor = document.getElementById('product-display-wrapper').getAttribute('data-product-color')
                // }else{
                //     productColor = context.querySelector('#product-display-wrapper').getAttribute('data-product-color')
                // }
                // if( subproduct.variants[0].option2 == productColor ){
                //     colorMatch = true;
                // }else{
                //     colorMatch = false;
                // }
                // let swatchStyle = '';
                // let matchedSwatchData = SWATCH_DATA.find( item => item.title === subproduct.variants[0].option2);
                // console.log('matchedSwatchData',matchedSwatchData);
                // if( matchedSwatchData ){
                //     if( matchedSwatchData.image ){
                //         swatchStyle = 'background-image:url('+matchedSwatchData.image+');';
                //     }else if( matchedSwatchData.color) {
                //         swatchStyle = 'background-color:'+matchedSwatchData.color+';';
                //     }else{
                //         swatchStyle = '';
                //     }
                // }
                // if( !swatches[subproduct.color_group] ) {
                //     swatches[subproduct.color_group] = [];
                // }
                // swatches[subproduct.color_group].push('<button title="'+subproduct.variants[0].option2+'" style="'+swatchStyle+'" data-color="'+subproduct.variants[0].option2+'" class="swatch-button' + ( colorMatch ? ' selected' : '' ) +'" data-product-handle="'+subproduct.handle+'" data-product-id="'+subproduct.id+'"><span class="u-sr-only">Select color: '+subproduct.variants[0].option2+'</span></button>');
            })
        }else{
            // swatches_container.classList.add('no-swatches')
        }

        // all_color_groups.forEach( group => {
        //     let color_section;
        //     if( context == 'pdp' ){
        //         color_section = document.querySelector('.option-select__label-list[data-color-group="'+group+'"]');
        //     }else{
        //         color_section = context.querySelector('.option-select__label-list[data-color-group="'+group+'"]');
        //     }
        //     console.log('swatches',swatches)
        //     if( swatches && swatches[group] && swatches[group].length > 0 ){
        //         color_section.setAttribute('data-swatch-count',swatches[group].length)
        //         swatches[group].forEach(swatch => {
        //             color_section.querySelector('.option-group__items').innerHTML += swatch;
        //         });
        //     }
        // });

        // swatches_container.innerHTML = swatches;
        return z;
    });
}
async function populateSwatchButtons(context = 'pdp'){
    // console.log('context',context)
    // let product_display_wrapper;
    // if( context == 'pdp' ){
    //     product_display_wrapper = document.getElementById('product-display-wrapper');
    // }else{
    //     product_display_wrapper = context.querySelector('#product-display-wrapper');
    // }
    let product_display_wrapper = document.querySelector('.product__info-wrapper');

    let product_group = product_display_wrapper.getAttribute('data-product-group');
    // console.log('product_group',product_group)
    let pdw = await getOtherProducts(product_group,context);
    return;
    let swatchButtons;
    if( context == 'pdp' ){
        swatchButtons = document.querySelectorAll('.swatch-button');
    }else{
        swatchButtons = context.querySelectorAll('.swatch-button');
    }
    swatchButtons.forEach( swatchButton => {
        // console.log('swatchButton,',swatchButton)
        swatchButton.addEventListener('click',function(e){
            e.preventDefault();
            let newProductHandle = e.target.getAttribute('data-product-handle');
            if( newProductHandle ) {
                if( context == 'pdp' ){
                    changeProductOnPDP(newProductHandle);
                }else{
                    changeProductOnPDP(newProductHandle,true,context);
                }
            }
        })
    });
    return;
}

async function changeProductOnPDP(productHandle,isQuickView = false,quickViewElement = 'pdp'){
    let sec;
    if( isQuickView === true && quickViewElement != 'pdp' ){
        // quickViewElement.querySelector('#product-display-wrapper').classList.add('loading');
        sec = await fetch(`${window.Shopify.routes.root}products/${productHandle}?sections=lq--product-header`).then( z => z.json() ).then( y => {
            quickViewElement.querySelector('.dialog_content').innerHTML = y['lq--product-header'];
        });
    }else{
        document.getElementById('product-display-wrapper').classList.add('loading');
        sec = await fetch(`${window.Shopify.routes.root}products/${productHandle}?sections=lq--product-header`).then( z => z.json() ).then( y => {
            document.getElementById('product-display-section').closest('.shopify-section').innerHTML = y['lq--product-header'];
        });
    }
    await initSizeGuideButton(quickViewElement);
    await initATC(quickViewElement);
    await initSizeRadios(quickViewElement);
    await populateSwatchButtons(quickViewElement);
    await initGenderToggleButtons(quickViewElement);
    await initGalleryZoom(quickViewElement);
    if( quickViewElement == 'pdp'){
        await resizeProductHeader();
    }
    return sec;
}
async function initGenderToggleButtons(context = 'pdp'){
    // console.log('gtb',context)
    let gender_toggle_buttons;
    if( context == 'pdp' ){
        gender_toggle_buttons = document.querySelectorAll('.gender-toggle__button');
    }else{
        gender_toggle_buttons = context.querySelectorAll('.gender-toggle__button');
    }
    gender_toggle_buttons.forEach( gender_toggle_button => {
        gender_toggle_button.addEventListener('click',function(e){
            e.preventDefault();

            // console.log('gender click')
            let opposite_product_handle = e.target.getAttribute('data-opposite-product-handle');
            if( opposite_product_handle ){
                if( context == 'pdp' ){
                    changeProductOnPDP(opposite_product_handle);
                }else{
                    changeProductOnPDP(opposite_product_handle,true,context);
                }
            }
        });
    });
    return;
}
async function resizeProductHeader(){
    let purchaseBoxHeight = document.querySelector('.product-display__purchase-box').clientHeight;
    document.getElementById('product-display-section').style.height = 'calc('+purchaseBoxHeight + 'px + 4rem)';
    return;
}
async function initSizeRadios(context = 'pdp'){
    // console.log('initSizeRadios')
    var fieldset;
    if( context == 'pdp' ){
        fieldset = document.querySelector('.product-form__option1');
    }else{
        fieldset = context.querySelector('.product-form__option1');
    }
    var radios = fieldset.querySelectorAll('input[name="option1"]');
    // console.log('radios',radios);

    var prev = null;
    for (var i = 0; i < radios.length; i++) {
        radios[i].addEventListener('change', function() {
            if (this !== prev) {
                prev = this;
            }
            let parent_label = prev.closest('.option-select__label');
            let variant_id = this.getAttribute('data-variant-id');
            let back_in_stock_button;
            let button, button_span;
            if( context == 'pdp' ){
                back_in_stock_button = document.querySelector('#product-display-wrapper .BIS_trigger');
                document.querySelector('input[name="id"]').value = variant_id;
                button = document.getElementById('product-form__atc__button');
                button_span = document.getElementById('product-form__atc__button__text__span');
            }else{
                back_in_stock_button = context.querySelector('.BIS_trigger');
                context.querySelector('input[name="id"]').value = variant_id;
                button = context.querySelector('#product-form__atc__button');
                button_span = context.querySelector('#product-form__atc__button__text__span');
            }
            // console.log('back_in_stock_button,',back_in_stock_button)
            if( parent_label.classList.contains('option-select__label--out-of-stock') ){
                if( parent_label.closest('#product-display-wrapper').getAttribute('data-back-in-stock') == 'true' ){
                    button.style.display = 'none';
                    back_in_stock_button.style.display = 'block';
                    back_in_stock_button.setAttribute('data-variant-id',variant_id);

                    if( context != 'pdp' ){
                        back_in_stock_button.addEventListener('click',function(){
                            context.close();
                        });
                    }
                }else{
                    button_span.textContent = 'Sold Out';
                    button.setAttribute('disabled','disabled');
                    if(back_in_stock_button){
                        back_in_stock_button.style.display = 'none';
                    }
                    button.style.display = 'block';
                }
            }else{
                button_span.textContent = 'Add to Cart';
                button.removeAttribute('disabled');
                if(back_in_stock_button){
                    back_in_stock_button.style.display = 'none';
                }
                button.style.display = 'block';
            }
        });
    }
    return;
}
async function initATC(context = 'pdp') {
    let form;
    if( context == 'pdp'){
        form = document.querySelector('[action="/cart/add"]');
    }else{
        form = context.querySelector('[action="/cart/add"]');
    }
    form.addEventListener('submit', async function(e){
        e.preventDefault();

        await fetch('/cart/add.js', {
            method: 'POST',
            body: new URLSearchParams(new FormData(e.target))
        })
        .then(response => {
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        return response.json(); 
        })
        .then(data => {
        // console.log('success');
        // Do something on success (e.g. show a success message)
        })
        .catch(error => {
        // console.log('ERROR');
        // Do something on error (e.g. show an error message)
        });
    });
}
async function initGalleryZoom(context = 'pdp') {
    let zoomable_images; 
    if( context == 'pdp' ){
        zoomable_images = document.querySelectorAll('.zoomable-image');
    }else{
        zoomable_images = context.querySelectorAll('.zoomable-image');
    }
    zoomable_images.forEach( zoomable_image => {
        zoomable_image.addEventListener('mousemove', (event) => {
            zoomable_image.style.setProperty('--display','block');
            let pointer = {
                x: (event.offsetX * 100) / zoomable_image.offsetWidth,
                y: (event.offsetY * 100) / zoomable_image.offsetWidth,
            }
            zoomable_image.style.setProperty('--zoom-x',pointer.x + '%');
            zoomable_image.style.setProperty('--zoom-y',pointer.y + '%');
        });
        zoomable_image.addEventListener('mouseout', (event) => {
            zoomable_image.style.setProperty('--display','none');
        });
    });
    let preview_photos;
    if( context == 'pdp' ){
        preview_photos = document.querySelectorAll('.product-carousel-main__preview-list__item__button');
    }else{
        preview_photos = context.querySelectorAll('.product-carousel-main__preview-list__item__button');
    }
    preview_photos.forEach( image => {
        image.addEventListener('click', (event) => {
            let carousel_main = event.target.closest('.product-carousel-main');
            let carousel = carousel_main.querySelector('.product-carousel-main__gallery');
            carousel.scrollLeft = carousel.offsetWidth * image.getAttribute('data-image-index');
        });
    });
    let product_carousel, pagination_dots;
    if( context == 'pdp' ){
        product_carousel = document.querySelector('.product-carousel-main__gallery');
        pagination_dots = document.querySelectorAll('.product-carousel-main__preview-list__item__button');
    }else{
        product_carousel = context.querySelector('.product-carousel-main__gallery');
        pagination_dots = context.querySelectorAll('.product-carousel-main__preview-list__item__button');
    }

    product_carousel.addEventListener('scrollsnapchange', () => {
        let product_carousel_item = product_carousel.querySelectorAll('.zoomable-image')[0];
        let product_carousel_item__width = product_carousel_item.clientWidth;
        let scroll_over_width = product_carousel.scrollLeft / product_carousel.clientWidth;
        let index = product_carousel.scrollLeft / product_carousel_item__width;
        
            if( index || index === 0 ) {
                pagination_dots.forEach(dot => {
                    if( dot.getAttribute('data-image-index') && dot.getAttribute('data-image-index') == index ) {
                        pagination_dots[index].classList.add('selected');
                    }else{
                        dot.classList.remove('selected');
                    }
                })
            }
	});
}
async function initSizeGuideButton(context = 'pdp') {
    let size_guide;
    if( context == 'pdp' ){
        size_guide = document.getElementById('open-size-guide');
    }else{
        size_guide = context.querySelector('#open-size-guide');
    }
    size_guide.addEventListener('click',function(e){
        e.preventDefault();
        let wrapper = e.target.closest('#product-display-wrapper');
        let current_gender = wrapper.getAttribute('data-product-gender');
        document.getElementById('lq--size-guide').showModal();

        if( current_gender != '' && current_gender != null ){
            let gender_buttons;
            if( context == 'pdp' ){
                gender_buttons = document.querySelectorAll('.lq--size-guide__gender-toggle__button');
            }else{
                gender_buttons = context.querySelectorAll('.lq--size-guide__gender-toggle__button');
            }
            gender_buttons.forEach( gbtn=>{
                if( gbtn.getAttribute('data-gender') == current_gender ){
                    gbtn.classList.add('selected');
                }else{
                    gbtn.classList.remove('selected')
                }
            });
        }
    });
}
function oofosThrottle(func, limit) {
    let inThrottle
    return function(...args) {
      if (!inThrottle) {
        func.apply(this, args)
        inThrottle = true
        setTimeout(() => inThrottle = false, limit)
      }
    }
}
async function fieldset_swatches(card = false){
    // console.log('fieldset-swatches -- card',card);
    let fieldset_swatches;
    if( card ){
        fieldset_swatches = card.querySelectorAll('.fieldset-swatches');
    }else{
        fieldset_swatches = document.querySelectorAll('.fieldset-swatches');
    }
    // console.log('fieldset-fieldset_swatches',fieldset_swatches);
    fieldset_swatches.forEach( fieldset => {
        // console.log('fieldset',fieldset);
        let swatches = fieldset.querySelectorAll('.swatch-button');
        // console.log('swatches',swatches)
        swatches.forEach(swatch => {
            swatch.addEventListener('change',async function(e){
                // console.log(e.target.dataset.productUrl)
                let productUrl = e.target.dataset.productUrl;
                await reset_card( e.target.closest('.product-card-wrapper').querySelector('.card'), productUrl)
                await initQuickAdd();
                initCardScrollers();
            })
        });
    });
}

async function reset_card(currentCard,productHandle){
    // console.log('reset_card')
    let section = await fetch(`${window.Shopify.routes.root}${productHandle.slice(1)}?sections=card`).then( z => z.json() ).then( y => {
        currentCard.innerHTML = y['card'];
    });
    await fieldset_swatches(currentCard);
    await initQuickAdd(currentCard);
    initCardScrollers();
}

async function initQuickAdd(card = false){
    let product_tiles;
    if( !card ){
        product_tiles = document.querySelectorAll('.product-card-wrapper');
    }else{
        product_tiles = [];
        product_tiles.push(card);
    }
    product_tiles.forEach(product_tile => {
        let quickAddButton = product_tile.querySelector('.quickadd-button')
        if( !quickAddButton ) return;
        // console.log('quickAddButton',quickAddButton)

        quickAddButton.addEventListener('click', async function(e){
            e.preventDefault();
            // console.log(e.target)
            let product_id = e.target.getAttribute('data-product-id');
            if( !product_id ) {
                product_id = e.target.closest('.quickadd-button').getAttribute('data-product-id');
            }
            // console.log('_-_--___----- quick view for: '+product_id)
            let this_dialog = 'dialog_'+product_id;
            // console.log('this_dialog',this_dialog)
            let dialog_element = document.getElementById(this_dialog);
            let dialog_content = dialog_element.querySelector('.dialog_content');
            let new_product_handle = dialog_element.getAttribute('data-product-handle');

            if( this_dialog ){
                let this_dialog_el = document.getElementById(this_dialog);
                this_dialog_el.showModal();
                // console.log('____----show it');
                await initGenderToggleButtons(this_dialog_el);
            }

            // let sec = await fetch(`${window.Shopify.routes.root}products/${new_product_handle}?sections=template--19652105011315__main`).then( z => z.json() ).then( y => {
            //     dialog_content.innerHTML = y['template--19652105011315__main'];
            // });
            // let sec = await fetch(`${window.Shopify.routes.root}products/${new_product_handle}?view=quickview`).then( y => {
            //     console.log('yy',y)
            //     dialog_content.innerHTML = y;
            // });
            let sec = await fetch(`${window.Shopify.routes.root}products/${new_product_handle}?sections=main-product`).then( z => z.json() ).then( y => {
                dialog_content.innerHTML = y['main-product'];
            });

            await fieldset_swatches();

            //
            const handleResize = oofosThrottle( async () => {
                await resizeProductHeader();
            }, 100)
            
            window.addEventListener('resize', handleResize);
            
            return sec;
        });
    });
}
async function toggleGenderModal(e){
    // console.log('e',e.dataset)
    if( !e ) return;

    if( !e.dataset.oppositeProductHandle ) return;

    let dialog_element = document.getElementById(e.id).closest('.quickview-modal');
    
    let dialog_content = dialog_element.querySelector('.dialog_content');
    let new_product_handle = e.dataset.oppositeProductHandle;

    let sec = await fetch(`${window.Shopify.routes.root}products/${new_product_handle}?sections=main-product`).then( z => z.json() ).then( y => {
        dialog_content.innerHTML = y['main-product'];
    });
}

function initCardScrollers(){
    console.log('initCardScrollers')
    let all_cards = document.querySelectorAll('.card.card--card');
    all_cards.forEach( card => {
        let variant_swatches = card.querySelector('variant-selects');
        let prev_btn = variant_swatches.querySelector('.variant-selects__nav--prev');
        let next_btn = variant_swatches.querySelector('.variant-selects__nav--next');
    
        // console.log("variant_swatches.clientWidth.querySelector('fieldset')",variant_swatches.querySelector('fieldset').clientWidth)
        // console.log("variant_swatches.closest('form').clientWidth",variant_swatches.closest('form').clientWidth)
        if( variant_swatches.querySelector('fieldset').clientWidth < variant_swatches.closest('form').clientWidth) {
            prev_btn.setAttribute('disabled','disabled');
            next_btn.setAttribute('disabled','disabled');
        }

        let swatch_count = variant_swatches.querySelectorAll('label').length;
        // console.log('swatch_count',swatch_count)
        let single_swatch_width = variant_swatches.querySelectorAll('label')[0].clientWidth;
        let swatches_width = single_swatch_width * (swatch_count - 1);
        // console.log('swatches_width',swatches_width)

        variant_swatches.addEventListener('scroll', () => {       
            // console.log('variant_swatches.scrollLeft',variant_swatches.scrollLeft)
            if( variant_swatches.scrollLeft  >= (swatches_width + (single_swatch_width * 3) ) ){
                next_btn.setAttribute('disabled','disabled');
                prev_btn.removeAttribute('disabled');
            }else if( variant_swatches.scrollLeft < 12 ) {
                prev_btn.setAttribute('disabled','disabled');
                next_btn.removeAttribute('disabled');
            }else{
                prev_btn.removeAttribute('disabled');
                next_btn.removeAttribute('disabled');
            }
        });
    
        prev_btn.addEventListener('click',function(){
            // console.log('prev')
            let scrollWidth = variant_swatches.querySelectorAll('label')[0].clientWidth;
            variant_swatches.scrollLeft -= scrollWidth * 3;
        });
        next_btn.addEventListener('click',function(){
            // console.log('variant_swatches.scrollLeft',variant_swatches.scrollLeft)
            let scrollWidth = variant_swatches.querySelectorAll('label')[0].clientWidth;
            variant_swatches.scrollLeft += scrollWidth * 3;
        });
    });
}
function carouselPrev(button) {
    let carousel = button.closest('.related-products').querySelector('.grid-carousel');
    let carouselItemWidth = carousel.querySelectorAll('.grid__item')[0].clientWidth;
    carousel.scrollLeft -= carouselItemWidth;
}
function carouselNext(button) {
    let carousel = button.closest('.related-products').querySelector('.grid-carousel');
    let carouselItemWidth = carousel.querySelectorAll('.grid__item')[0].clientWidth;
    carousel.scrollLeft += carouselItemWidth;
}
//swatchNavPrev
function swatchNavPrev(button) {
    console.log('swatchNavPrev');
    let carousel = button.closest('variant-selects').querySelector('fieldset');
    let carouselItemWidth = carousel.querySelectorAll('.swatch-button--card')[0].clientWidth;
    carousel.scrollLeft -= carouselItemWidth * 2;
}
function swatchNavNext(button) {
    console.log('swatchNavNEXT');
    let carousel = button.closest('variant-selects').querySelector('fieldset');
    console.log('carousel',carousel);
    let carouselItemWidth = carousel.querySelectorAll('.swatch-button--card')[0].clientWidth;
    console.log('carouselItemWidth',carouselItemWidth);
    carousel.scrollLeft += carouselItemWidth * 2;
}